import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ManagerHeader from "../manager-dashboard/ManagerHeader.js";
import api from "../../api/axios.js";

const ManagerFeedbackList = () => {
  const navigate = useNavigate();
  const [employees, setEmployees] = useState([]);

  const managerId = "101";

  // get employee list
  useEffect(() => {
    api
    .get("/api/feedback/manager/" + managerId + "/employees")
    .then((res) => {
      setEmployees(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
  }, []);

  useEffect(() => {
}, [employees]);


  return(
    <>
      <div className="dashboard-wrapper">
        <ManagerHeader />
        <h3>Select employee to give feedback</h3>

        <div className="manager_feedback_list">
          {employees.map((employee) => {
            return(
              <div
                key={employee.employeeId}
                className="manager_employee_card"
                onClick={() => {
                  navigate("/manager/feedback/"+employee.employeeId+"/quizzes")
                }}
                >
                  <img
                    src="/images/profile-1.png"
                    alt="profile-icon"
                  />
                  <span>{employee.employeeName}</span>
                </div>
            );
          })}
        </div>
      </div>
    </>
  )
}

export default ManagerFeedbackList;